import React,{useEffect} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import '../../../component/ReuseableComponent/ReuseableComponent.css';
import Modal from '@mui/material/Modal';
import '../../../component/ToolBox/ToolBox.css';
import Button from '@mui/material/Button';

import {
  CmpTypographyField,
  CmpInputField,
  CmpButtonWithIcon
} from '../../../component/ToolBox/ToolBox';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { CSVLink, CSVDownload } from 'react-csv';

const fDummyFunction = () => {};
const gridBox = {
  border: '1px solid #DADBD6',
  padding: 0.5
};
const borderBox = {
  height: '65vh',
  padding: 0.5
};
const gridItemSpacing = {
  display: 'flex',
  alignItems: 'center',
  padding: 0.2,
  justifyContent: 'flex-start'
};

const MissingBranch = ({
  xOpen = 'false',
  xTitle = '',
  fCloseModal,
  xPostedRowInfo = [],
  xLoadDetailRow = [],
  xLoadDetailCol = [],
  xfetchPost = () => {},
  xRowHeight = 30,
  xHeaderHeight = 40,
  borderColorChange = false
}) => {
  const vMediaQuery = useMediaQuery('(max-width:650px)');
  return (
    <Modal
      open={xOpen}
      onClose={fCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={{ flexGrow: 1, overflow: 'auto' }} className="gnr-item-search model-gc-search">
        <Grid
          container
          spacing={0}
          columns={{ xs: 12, sm: 12, md: 12 }}
          className="GCSearchBtn-Tittle"
          sx={{ alignItems: 'center' }}>
          <Grid item xs={11} sm={11} md={11} className="d-flex justify-content-center  ">
            <div>{xTitle}</div>
          </Grid>
          <Grid item xs={1} sm={1} md={1} className="d-flex justify-content-end">
            <CloseIcon
              className="grnt-item-search-close-icon"
              onClick={!!fCloseModal ? fCloseModal : fDummyFunction}
              style={{ zIndex: 999 }}
            />
          </Grid>
        </Grid>
        <Box sx={gridBox}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ p: '5px' }}>
              <Grid container>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Grid container>
                    <Grid item xs={3} sm={2} md={2} lg={2} sx={gridItemSpacing}>
                      <CmpTypographyField
                        xcomponent={'p'}
                        xText={'Voucher Type'}
                        xVariant={'subtitle'}
                      />
                    </Grid>
                    <Grid item xs={9} sm={10} md={10} lg={10} sx={gridItemSpacing}>
                      <Grid
                        container
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}>
                        <Grid item xs={2} sm={2} md={2} lg={2} sx={gridItemSpacing}>
                          <CmpInputField
                            xValue={xPostedRowInfo.vocTyp}
                            xType={'text'} // text/number/password
                            xName={'docNo'}
                            xReadOnly={true}
                            xOnChange={''}
                            xError={false}
                            xErrorMessage={''}
                            xOnKeyUp={''}
                          />
                        </Grid>
                        <Grid item xs={10} sm={10} md={10} lg={10} sx={gridItemSpacing}>
                          <CmpInputField
                            xValue={xPostedRowInfo.vocName}
                            xType={'text'} // text/number/password
                            xName={'docName'}
                            xReadOnly={true}
                            xOnChange={''}
                            xError={false}
                            xErrorMessage={''}
                            xOnKeyUp={''}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <Grid container>
                    <Grid item xs={3} sm={2} md={2} lg={2} sx={gridItemSpacing}>
                      <CmpTypographyField
                        xcomponent={'span'}
                        xText={'Voucher No'}
                        xVariant={'subtitle'}
                      />
                    </Grid>
                    <Grid item xs={9} sm={10} md={10} lg={10} sx={gridItemSpacing}>
                      <CmpInputField
                        xValue={xPostedRowInfo.vocNo}
                        xType={'text'} // text/number/password
                        xName={'vocNo'}
                        xReadOnly={true}
                        xOnChange={''}
                        xError={false}
                        xErrorMessage={''}
                        xOnKeyUp={''}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <Grid container>
                    <Grid item xs={3} sm={2} md={2} lg={2} sx={gridItemSpacing}>
                      <CmpTypographyField
                        xcomponent={'span'}
                        xText={'Date'}
                        xVariant={'subtitle'}
                      />
                    </Grid>
                    <Grid item xs={9} sm={10} md={10} lg={10} sx={gridItemSpacing}>
                      <CmpInputField
                        xValue={moment(xPostedRowInfo.vocDt).format('DD/MM/YYYY')}
                        xType={'text'} // text/number/password
                        xName={'date'}
                        xReadOnly={true}
                        xOnChange={''}
                        xError={false}
                        xErrorMessage={''}
                        xOnKeyUp={''}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Grid container sx={{ height: vMediaQuery ? '100%' : '' }}>
          <Grid item xs={12} md={12} sm={12} lg={12}>
            <Box sx={borderBox}>
              <DataGrid
                rows={xLoadDetailRow}
                columns={xLoadDetailCol}
                rowHeight={xRowHeight}
                headerHeight={xHeaderHeight}
                sx={{
                  border: 2,
                  borderColor: borderColorChange ? '#DADBD6' : 'primary.light'
                }}
                componentsProps={{
                  filterPanel: { sx: { maxWidth: "93vw" } }
                }}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'mui-even-row' : 'mui-odd-row'
                }
                hideFooter
                checkboxSelection={false}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ px: '10px' }}>
            <div style={{ width: '10%', margin: '0 auto' }}>
              <Button
                variant={'contained'}
                disabled={false}
                size={'medium'}
                onClick={() => {}}
                className="btn-text-transform-none inputfont mui-btn-wt-icon"
                startIcon={''}>
                <CSVLink
                  data={xLoadDetailRow}
                  filename={'MissingBranch.csv'}
                  style={{ color: 'white', textDecoration: 'none' }}>
                  Export
                </CSVLink>
              </Button>
            </div>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default MissingBranch;
